module.exports = __webpack_public_path__ + "static/media/time-management.e70ada9b.png";